import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="pt-20 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          {/* Left Content */}
          <div>
            <div>
              <h2 className="text-4xl font-light text-gray-800">
                {t.about.heading}
              </h2>
              <div className="w-16 h-0.5 bg-gray-800 mt-8 mb-12"></div>
            </div>
            <div className="space-y-8">
              <div>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  {t.about.founderTitle}
                </h2>
                <div className="space-y-4">
                  {t.about.founder.map((paragraph, index) => (
                    <p key={index} className="text-gray-600 leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  {t.about.missionTitle}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t.about.mission}
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  {t.about.visionTitle}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {t.about.vision}
                </p>
              </div>
            </div>
          </div>

          {/* Right Content - Image with Animation */}
          <div className="fl-module fl-module-photo fl-animation fl-fade-right flex justify-end">
            <div className="w-[520px]">
              <img
                src="/bw_hd_aboutus.jpg"
                alt={t.about.imageAlt}
                className="w-full h-auto grayscale"
                style={{
                  borderRadius: "150px 8px 8px 8px",
                  filter: "drop-shadow(5px 5px 20px rgba(0, 0, 0, 0.25))",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
